import React from 'react';
import { FirebaseApp } from 'firebase/app';
import { User } from 'firebase/auth';
import { getFunctions } from 'firebase/functions';
import { getCourierAuthToken } from '../api/cloudFunctions';

// Tokens are issued with a 1h expiry, so refresh well before that
const REFRESH_INTERVAL_MS = 45 * 60 * 1000;

/**
 * Fetches a short-lived Courier JWT for the signed-in user and keeps it
 * fresh. Courier's client API no longer accepts unsigned client-key auth,
 * so all Courier fetches (notification preferences etc.) require this token.
 */
function useCourierAuthToken(app: FirebaseApp | undefined, user: User | null) {
  const [token, setToken] = React.useState<string>();
  const uid = user?.uid;

  React.useEffect(() => {
    if (!app || !uid) {
      setToken(undefined);
      return;
    }

    let cancelled = false;
    const fetchToken = async () => {
      try {
        const result = await getCourierAuthToken(getFunctions(app));
        if (!cancelled) {
          setToken(result.token);
        }
      } catch (e) {
        console.error('Failed to fetch Courier auth token', e);
      }
    };

    fetchToken();
    const interval = setInterval(fetchToken, REFRESH_INTERVAL_MS);
    return () => {
      cancelled = true;
      clearInterval(interval);
    };
  }, [app, uid]);

  return token;
}

export default useCourierAuthToken;
